import store from 'app-store';
import { SET, CLEAR_PAGE_DATA } from './action-types';

// Action creators
export function set(data) {
  store.dispatch({
    type: SET,
    data
  });
}

export function clearPageData() {
  store.dispatch({
    type: CLEAR_PAGE_DATA
  });
}
